module.exports = __webpack_public_path__ + "img/project13_6.jpg.4a4b82e9.webp";